





















import { Component, Prop, Emit, Vue } from 'vue-property-decorator'
import CoreIcon from './CoreIcon.vue'

@Component({
    components: { CoreIcon },
})
export default class CoreCopyContentInput extends Vue {
    @Prop({ default: '' }) public placeholder!: string
    @Prop({ default: false }) public readonly!: boolean
    @Prop() public value!: string

    public active = false

    public focus() {
        this.active = true
    }

    public copyContent() {
        const copyText = this.$refs.inputText as HTMLInputElement
        copyText.select()
        document.execCommand('copy')
    }

    public get withSuffix() {
        return !!this.$slots.suffix
    }

    public get inputInnerClasses() {
        return {
            active: this.active,
            readonly: this.readonly,
        }
    }

    @Emit('input')
    public input(e: any): string {
        this.change()
        return e.target.value
    }

    @Emit('change')
    public change(): string {
        return this.value
    }

    @Emit('blur')
    public blur() {
        this.active = false
    }
}
